var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
import { HttpParams } from '@angular/common/http';
import { Reflection } from 'path-shared/services/reflection/reflection';
var defaultSortParam = 'EXP';
var defaultSortDirection = 'asc';
var NotificacionsPuntsDGTFilterService = /** @class */ (function (_super) {
    __extends(NotificacionsPuntsDGTFilterService, _super);
    function NotificacionsPuntsDGTFilterService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotificacionsPuntsDGTFilterService.prototype.createFilterParams = function (filter, start, pageSize, sortField, sortDir) {
        if (filter.fechaInicio !== undefined && filter.fechaInicio !== null) {
            var tempDate = new Date(+filter.fechaInicio);
            tempDate.setHours(0, 0, 1);
            filter.fechaInicio = tempDate;
        }
        if (filter.fechaFin !== undefined && filter.fechaFin !== null) {
            var tempDate = new Date(+filter.fechaFin);
            tempDate.setHours(23, 59, 59);
            filter.fechaFin = tempDate;
        }
        return new HttpParams()
            .append('EXP', filter.EXP ? filter.EXP : '')
            .append('fechaInicio', Reflection.empty(filter.fechaInicio) ? null : typeof (filter.fechaInicio) === 'string' ?
            filter.fechaInicio : filter.fechaInicio.toDateString())
            .append('fechaFin', Reflection.empty(filter.fechaFin) ? null : typeof (filter.fechaFin) === 'string' ?
            filter.fechaFin : filter.fechaFin.toDateString())
            .append('start', start.toString())
            .append('size', pageSize.toString())
            .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
            .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
    };
    return NotificacionsPuntsDGTFilterService;
}(CustomFilterService));
export { NotificacionsPuntsDGTFilterService };
